<script setup>
import { useToast } from '@/composables/use-toast'

const { toasts, removeToast, pauseToast, resumeToast } = useToast()
</script>

<template>
  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="toast">
        <div v-for="toast in toasts" :key="toast.id" 
           class="toast" 
           :class="[`toast--${toast.type}`]"
           @mouseenter="pauseToast(toast.id)"
           @mouseleave="resumeToast(toast.id)">
        <div class="toast__content">
          <span class="toast__message" :class="toast.type === 'loading' ? 'flex items-center' : ''">
            <svg v-if="toast.type === 'loading'" class="toast__loading w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ toast.message }}
          </span>
          <button v-if="toast.type !== 'loading'" class="toast__close" @click="removeToast(toast.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped lang="postcss">
.toast-container {
  @apply fixed z-[9999] flex flex-col gap-2 bottom-4 left-4 right-4 md:left-auto md:right-4;
}

.toast {
  @apply w-full sm:min-w-[300px] md:max-w-md bg-echoes-background-black rounded-lg shadow-md border border-echoes-border-gray;
}

.toast--success {
  @apply border-l-4 border-l-green-500 dark:border-l-green-500;
}

.toast--error {
  @apply border-l-4 border-l-red-500 dark:border-l-red-500;
}

.toast--loading {
  @apply border-l-4 border-l-violet-500 dark:border-l-violet-500;
}

.toast--warning {
  @apply border-l-4 border-l-yellow-500 dark:border-l-yellow-500;
}

.toast__content {
  @apply flex items-center justify-between p-4;
}

.toast__message {
  @apply text-sm text-white break-words;
  @apply mr-2;
}

.toast__loading {
  @apply animate-spin mr-2;
}

.toast__close {
  @apply text-white/80 hover:text-white;
}

.toast-enter-active,
.toast-leave-active {
  @apply transition-all duration-300 ease-in-out;
}

.toast-enter-from {
  @apply opacity-0 translate-x-full;
}

.toast-leave-to {
  @apply opacity-0 translate-y-full;
}
</style> 